import app from '@/app';

app.factory('Register', Register);

/* @ngInject */
function Register($resource) {
	return $resource('api/register', {}, {});
}
